import api from '../api';

export type EventType = 'page_view' | 'user_registered' | 'reached_resumo' | 'finalized';

export interface TrackingEvent {
  event_type: EventType;
  session_id?: string;
  empresa_id?: number;
  pedido_id?: number;
  metadata?: any;
}

class TrackingService {
  private sessionId: string | null = null;

  constructor() {
    if (typeof window !== 'undefined') {
      // Gerar ou recuperar session ID
      this.sessionId = this.getOrCreateSessionId();
    }
  }

  private getOrCreateSessionId(): string {
    if (typeof window === 'undefined') return '';
    
    let sessionId = sessionStorage.getItem('tracking_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('tracking_session_id', sessionId);
    }
    return sessionId;
  }

  async trackEvent(event: TrackingEvent): Promise<void> {
    try {
      await api.post('/scheduling-events', {
        ...event,
        session_id: event.session_id || this.sessionId,
      });
      console.log('📊 [TrackingService] Evento registrado:', event.event_type);
    } catch (error) {
      console.error('❌ [TrackingService] Erro ao registrar evento:', error);
      // Não lançar erro para não quebrar o fluxo do usuário
    }
  }

  trackPageView(page: string, metadata?: any): void {
    this.trackEvent({
      event_type: 'page_view',
      metadata: {
        page,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        ...metadata,
      },
    });
  }

  trackUserRegistered(empresaId: number, metadata?: any): void {
    this.trackEvent({
      event_type: 'user_registered',
      empresa_id: empresaId,
      metadata,
    });
  }

  trackReachedResumo(empresaId?: number, metadata?: any): void {
    this.trackEvent({
      event_type: 'reached_resumo',
      empresa_id: empresaId,
      metadata,
    });
  }

  trackFinalized(pedidoId: number, empresaId?: number, metadata?: any): void {
    this.trackEvent({
      event_type: 'finalized',
      pedido_id: pedidoId,
      empresa_id: empresaId,
      metadata,
    });
  }
}

export const trackingService = new TrackingService();

